import { Button } from '@liveauctioneers/hammer-ui-core/button';

import BidConsoleOpener from '@/components/BidConsoleOpener/BidConsoleOpener';
import { ItemCardLiveBidButton } from '@/components/GridItemCard/Card/components/ItemCardBidButton/ItemCardLiveBidButton';
import { useAppSelector } from '@/redux/hooks';
import { getRegistrationDeclined } from '@/redux/modules/catalog/registration/catalogRegistration.selectors';
import {
    getItemSummaryCatalogId,
    getItemSummaryCatalogStatus,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export type CardBiddingProps = { itemId: number; showLiveBidButton: boolean };

export const CardBidding = ({ itemId, showLiveBidButton }: CardBiddingProps) => {
    const formatMessage = useAppFormatMessage();
    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, itemId));
    const catalogStatus = useAppSelector((state) => getItemSummaryCatalogStatus(state, itemId));

    const declined = useAppSelector((state) => getRegistrationDeclined(state, catalogId));

    return (
        <>
            {catalogStatus === 'live' && !declined && (
                <section
                    className="[grid-area:bidButtonForLiveItem]"
                    data-testid="myItemsCardBidding"
                >
                    <BidConsoleOpener catalogId={catalogId}>
                        <Button
                            aria-label="Enter live auction button"
                            className="w-full xsMax:w-[211px]"
                            data-testid="enter-auction-container"
                            size="sm"
                            style="critical"
                            variant="filled"
                        >
                            {formatMessage(['enter_live_auction_mobile'])}
                        </Button>
                    </BidConsoleOpener>
                </section>
            )}
            {showLiveBidButton && (
                <section
                    className="[grid-area:bidButtonForLiveItem]"
                    data-testid="myItemsCardBidding"
                >
                    <ItemCardLiveBidButton itemId={itemId} />
                </section>
            )}
        </>
    );
};
